import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';
import { useMemo } from 'react';

import { StatsIcon as DumbStatsIcon } from '@sorare/core/src/components/draft/StatsIcon';
import { normalizeStatsFromRawScores } from '@sorare/core/src/lib/performance';

import type { AnyPlayerStatsIcon_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: AnyPlayerStatsIcon_anyPlayer;
  onClick?: ComponentProps<typeof DumbStatsIcon>['onClick'];
} & Pick<ComponentProps<typeof DumbStatsIcon>, 'outlined' | 'backgroundColor'>;

export const AnyPlayerStatsIcon = ({
  player,
  onClick,
  ...dumbStatIconProps
}: Props) => {
  // oxlint-disable-next-line react/preserve-manual-memoization
  const stats = useMemo(() => {
    return normalizeStatsFromRawScores(
      player?.rawPlayerGameScores || [],
      player.sport,
      5
    );
    // oxlint-disable-next-line react/preserve-manual-memoization
  }, [player?.rawPlayerGameScores, player.sport]);

  return (
    <DumbStatsIcon stats={stats} onClick={onClick} {...dumbStatIconProps} />
  );
};

AnyPlayerStatsIcon.fragments = {
  anyPlayer: gql`
    fragment AnyPlayerStatsIcon_anyPlayer on AnyPlayerInterface {
      slug
      rawPlayerGameScores(last: 5)
      sport
    }
  ` as TypedDocumentNode<AnyPlayerStatsIcon_anyPlayer>,
};
